import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendar3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-3, date"} maskId="square-filled-radius-0-stroke-1-IconCalendar3"><path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H16V4H8V2H7V4ZM7 9V8H17V9H7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendar3;
